import { createApp } from "vue";
import { registerScrollSpy } from "vue3-scroll-spy";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import "./styles/element/index.scss";
import ElementPlus from "element-plus";
// import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import App from "./App.vue";
import router from "./router";
import { useApiStore } from "./stores/api";
import { useUserStore } from "@/stores/user";
import { version } from "../public/version";
import "./assets/base.css";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(ElementPlus, {
  locale: zhCn
});
app.use(router);
// 使用默认配置
registerScrollSpy(app);
app.use(pinia);
app.mount("#app");

const api = useApiStore();
const user = useUserStore();

// if (this.$route.path.indexOf("/login") === -1 && !user.isLogin) {
//   // 如果访问的不是登录页面，并且用户没有登录状态
//   console.log("未登录");
//   this.$router.replace({ name: "login" });
// }
if(import.meta.env.VITE_ENV != 'production'){
  console.log('开发环境')
}
if(import.meta.env.VITE_ENV == 'production'){
  console.log('生产环境')
  if(window){
      window.console.log = function(){}

  }
}

router.beforeEach((to, from, next) => {

  api.getLastVersion().then((res) => {
    const lastVersion = res.data.version;
    const currentVersion = version;
    console.log("检查版本号", currentVersion, lastVersion);

    if (lastVersion !== currentVersion) {
      this.$router.replace({ name: "login" });
    }
  });


  next();
});
